export default "__VITE_ASSET__bdf3da14__"